// ── 직원 등록·수정 창 부서 상자 + '+ 새 부서 추가' (2026-11-03 사용자 "부서선택에 +새근무유형추가처럼 부서 추가") ──
// 결정 1a: 고르면 상자 바로 아래 한 줄 [새 부서 이름][추가][취소] — Enter = 추가, Esc = 닫기. 결정 2a: 수정 창에도(같은 창).
// 이 화면 회사 부서를 고칠 수 있는 사람(☰ 부서 설정이 보이는 사람 — settings.canManage)에게만 보인다(fail-closed).
// 저장은 ☰ 부서 설정과 같은 길(settings.addDepartment → POST /api/admin/departments — 같은 이름 409·변경 기록은 서버가).
// 추가되면 목록을 다시 읽고 그 부서를 바로 고른다.
import React, { useEffect, useState } from 'react';
import { inputStyle } from './styles';
import { stdBlackBtn, stdOutlineBtn } from '../adminlayout/designStandard';

const ADD = '__add_department__';

export default function DepartmentSelect({ value, onChange, departments, settings, open }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const canAdd = Boolean(settings?.canManage && settings?.addDepartment);
  const busy = Boolean(settings?.saving);

  // 창이 닫히면 적던 이름도 비운다
  useEffect(() => { if (!open) { setAdding(false); setName(''); } }, [open]);

  const close = () => { setAdding(false); setName(''); };
  async function add() {
    const trimmed = name.trim();
    if (!trimmed || busy) return;
    if (await settings.addDepartment(trimmed)) {
      onChange(trimmed);
      close();
    }
  }

  return (
    <>
      <select
        style={inputStyle}
        value={value}
        onChange={(e) => {
          if (e.target.value === ADD) { setAdding(true); return; }
          onChange(e.target.value);
        }}
      >
        <option value="">부서 선택</option>
        {departments.map((d) => <option key={d} value={d}>{d}</option>)}
        {canAdd && <option value={ADD}>+ 새 부서 추가</option>}
      </select>
      {canAdd && adding && (
        <div style={addRow}>
          <input
            style={{ ...inputStyle, flex: 1, minWidth: 0 }}
            placeholder="새 부서 이름"
            value={name}
            maxLength={100}
            autoFocus
            disabled={busy}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') { e.preventDefault(); add(); }
              else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
            }}
          />
          <button type="button" style={stdBlackBtn} disabled={busy || !name.trim()} onClick={add}>추가</button>
          <button type="button" style={stdOutlineBtn} disabled={busy} onClick={close}>취소</button>
        </div>
      )}
    </>
  );
}

// 칸 격자에서 한 줄 전체 — 부서 상자 바로 아래에 온다
const addRow = { gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: 8 };
